import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useCallback,
} from "react";
import styles from "./index.module.css";
import ReportTablePlatinumPlus from "Reporting/Components/ReportTablePlatinumPlus";
import { usePlatinumPlusGet } from "./usePlatinumPlusGet";
import Loader from "shared/Loader";

export default function ReportTableListPlatinumPlus({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  const [visibleRowsByReport, setVisibleRowsByReport] = useState({});
  const [selectedColumnsByReport, setSelectedColumnsByReport] = useState({});

  const { data, isLoading, isError, refetch } = usePlatinumPlusGet(filters);

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger, refetch]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    setReports(data);
    setReportsLength?.(data.length || 0);
  }, [data, setReportsLength]);

  const handleSortedReportsChange = useCallback((title, sortedRows) => {
    setVisibleRowsByReport((prev) => ({
      ...prev,
      [title]: Array.isArray(sortedRows) ? sortedRows : [],
    }));
  }, []);

  const handleSelectedColumnsChange = useCallback((title, columns) => {
    setSelectedColumnsByReport((prev) => ({
      ...prev,
      [title]: columns,
    }));
  }, []);

  useLayoutEffect(() => {
    if (reports.length === 0) {
      setReportData?.(null);
      return;
    }

    const reportsWithProcessed = reports.map((report) => ({
      ...report,
      rows: visibleRowsByReport[report.reportTitle] || (Array.isArray(report.rows) ? report.rows : []),
      selectedColumns: selectedColumnsByReport[report.reportTitle] || [],
    }));

    setReportData?.(reportsWithProcessed);
  }, [reports, visibleRowsByReport, selectedColumnsByReport, setReportData]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <ReportTablePlatinumPlus
          key={index}
          report={report}
          title={report.reportTitle}
          onSortedReportsChange={handleSortedReportsChange}
          selectedColumns={selectedColumnsByReport[report.reportTitle] || []}
          onSelectedColumnsChange={handleSelectedColumnsChange}
        />
      ))}
    </div>
  );
}
